import React from 'react';
import styled, {css} from 'styled-components';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {CalendarWeekDaysShortEnum} from '../../../models/api/calendarCommonTypes';

/*
  Props.
*/

interface BusinessHoursDialogWeekdayButtonProps {
  weekday: CalendarWeekDaysShortEnum;
  onClick: HandlerOf<CalendarWeekDaysShortEnum>;
  active: boolean;
}

/*
  Style.
*/

const StyledButton = styled(ChromelessButton)<{$active?: boolean}>`
  width: 30px;
  height: 30px;
  padding: 8px 0;
  border-radius: 50%;
  text-align: center;
  font-size: 13px;
  text-transform: uppercase;
  background: ${(p) => p.theme.greys.shade20};
  color: ${(p) => p.theme.greys.shade80};

  &:hover {
    background: ${(p) => p.theme.greys.shade50};
  }

  ${({$active, theme}) =>
    $active &&
    css`
      background: ${theme.palette.blue.shade40};
      color: ${theme.greys.white};

      &:hover {
        background: ${theme.palette.blue.shade50};
      }
    `}
`;

/*
  Component.
*/

export const BusinessHoursDialogWeekdayButton = ({
  weekday,
  onClick,
  active,
}: BusinessHoursDialogWeekdayButtonProps) => (
  <StyledButton
    onClick={() => onClick(weekday)}
    $active={active}
    aria-label={weekday}
    interactionId={`${weekday}-button`}
  >
    {weekday.substring(0, 1)}
  </StyledButton>
);
